export const SELECTED_TEAM_ID_STORAGE_KEY = 'Forecasting:selectedTeamID';
export const FORECAST_TYPE_KEY = 'Forecasting:forecastType';
export const FORECAST_TAB_KEY = 'Forecasting:forecastTabKey';